import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index"
import Layout from '@/layout/index'
Vue.use(VueRouter)
// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    // {
    //     path: '*',
    //     redirect: '/home'
    // },
    {
        path: '*',
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'pageHome',
                component: () => import('@/views/home')
            },
            {
                path: '/address',
                name: 'address',
                component: () => import('@/views/address')
            },
            {
                path: '/cart',
                name: 'cart',
                component: () => import('@/views/cart')
            },
            {
                path: '/about',
                name: 'about',
                component: () => import('@/views/detail/about.vue')
            },
            {
                path: '/contact',
                name: 'contact',
                component: () => import('@/views/detail/contact.vue')
            },
            {
                path: '/news',
                name: 'news',
                component: () => import('@/views/news')
            },
            {
                path: '/newsDetail',
                name: 'newsDetail',
                component: () => import('@/views/news/detail.vue')
            },
            {
                path: '/order',
                name: 'order',
                component: () => import('@/views/order')
            },
            {
                path: '/product',
                name: 'product',
                component: () => import('@/views/product')
            },
            {
                path: '/newproduct',
                name: 'newproduct',
                component: () => import('@/views/product/newProduct')
            },
            {
                path: '/proDetail',
                name: 'proDetail',
                component: () => import('@/views/product/proDetail')
            },
            {
                path: '/video',
                name: 'video',
                component: () => import('@/views/video')
            },
            {
                path: '/personal',
                name: 'personal',
                component: () => import('@/views/personal')
            },
            {
                path: '/order',
                name: 'order',
                component: () => import('@/views/order')
            },
            {
                path: '/order/detail',
                name: 'orderDetail',
                component: () => import('@/views/order/detail')
            }
        ]
    },
]

const router = new VueRouter({
    mode: 'hash',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (to.path == '/home') {
                let screenTop = JSON.parse(localStorage.getItem('scrollTop'));
                return { x: 0, y: screenTop }
            } else {
                return { x: 0, y: 0 }
            }
        }
    }
})

router.beforeEach((to, from, next) => {
    let obj = store.state.user
    next()
})

export default router